<template>
  <!-- 协作详情的分享页面 -->
  <div class="wrap">
    <div class="is-weiXin-tip hidden" :class="{'show':is_weixn()}">
      <img class="tip-open" src="@/assets/case-share-detail/what_tip.png" alt="">
    </div>
    <div class="content-wrap">
      <!--  案件协作    -->
      <div class="case-box">
        <div class="case-tit flex flex-space-between"> <h5>案件协作 <label>{{detail.bizTypeLabel}}</label> </h5>    <i :class="[statusText === '待接单' && 'green-color']">{{statusText}}</i> </div>
        <div class="case-texts">
          <p> <label>详细需求</label>  <span class="fs15">{{detail.info}}</span> </p>
          <p> <label>发布时间</label>  <span>{{detail.createTime}}</span></p>
          <p> <label>协作地区</label>  <span>{{detail.provinceName}}-{{detail.regionName}}</span></p>
          <p> <label>预算金额</label>  <span class="money">¥{{priceYuan(detail.amount)}}</span></p>
          <p> <label>接单响应</label>  <span class="lawyers"> <img v-for="imgSrc in detail.jdLawyerList"   :key="imgSrc.id" :src="imgSrc.jdLawyerAvatar" /> 已有{{detail.jdLawyerList.length}}位律师响应</span></p>
        </div>
      </div>
      <!--  接单律师    -->
      <div class="case-box lawyers-box">
<!--        <div class="case-tit"> <h5>接单律师</h5>  </div>-->
        <ul class="lawyer-infos">
          <li class="flex flex-space-between flex-align-center">
            <div class="lawyer-text">
              <img class="lawyer-header" :src="detail.fbLawyerAvatar" />
              <div>
                <p class="lawyer-name">{{detail.fbLawyerName || '暂无'}} <label class="fs12 ">发单律师</label> </p>
                <p> <img class="lawyer-icon" src="@/assets/imgs/share-page/icons.png">已通过法临官方认证 </p>
              </div>
            </div>
          </li>
        </ul>
      </div>
      <!--  温馨提示    -->
      <div  class="case-box con-prompt">
        <p class="fs14 con-prompt-tit">法临温馨提示</p>
        <div class="fs12 con-prompt-texts">
          <p>1.法临仅为双方提供信息展示和沟通平台，请自行确认对方协作信息的真实性后再进行合作，避免给您带来不必要的损失</p>
          <p>2.协作费用由发单、接单双方律师自主协商并自行完成支付， 法临不收取也不担保任何费用</p>
        </div>
      </div>

    </div>
    <div class="footers">
      <button @click="openApp">立即前往APP</button>
      <p>您还没安装法临律师端APP？请点击 <a @click="buttonDownload" >立即下载</a></p>
    </div>
  </div>
</template>

<script>
import goApp from "@/mixins/goApp";
import { lawyerCollaboration} from "@a/case-share-detail";
import {priceYuan} from "../../libs/tool";

export default {
  name: "collaboration",
  methods: {priceYuan},
  data(){
    return{
      detail:{
        createTime:'2022-12-23 34:34',
        status:1,
        jdLawyerList:[]
      }
    }
  },
  mixins:[goApp],
  computed:{
    // 状态(1.待接单、2.已匹配（已接单）、9.已关闭)
    statusText(){
      let text ='已匹配'
      switch (Number(this.detail.status)) {
        case 1:
           text = '待接单'
          break
        case 9:
          text = '已关闭'
          break
        default:
          text = '已匹配'
          break
      }
      return text
    }
  },
  mounted() {
    lawyerCollaboration({id: this.$route.query?.id}).then(r=>{
      this.detail = r.data
    })
  }
}
</script>

<style lang="scss" scoped>
.wrap{
  padding-bottom: 130px;
  background-color: #F5F5F7;
}
.banner{
  width: 100%;
}
.is-weiXin-tip{
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0,0,0,0.5);
  z-index: 20;
  text-align: right;
  .tip-open{
    width: 5.08rem;
    height: 3.52rem;
    position: fixed;
    z-index: 5;
    top: 0;
    right:0.12rem;
  }
}
.content-wrap{
  //border-radius: 16px 16px 0px 0px;
  background-color: #F5F5F7;
  padding: 12px;
  .case-box{
    background: #FFFFFF;
    border-radius: 12px 12px 12px 12px;
    padding: 16px;
    margin-bottom: 12px;

    .case-tit{
      border-bottom: 0.5px solid #EEEEEE;
      padding-bottom: 16px;

      .green-color{
        color: #22BF7E;
        &:before{
          content: ' ';
          display: inline-block;
          width: 5px;
          height: 5px;
          background: #22BF7E;
          vertical-align: middle;
          margin-right: 4px;
          border-radius: 50%;
        }
      }

      h5{
        font-weight: 500;
        font-size: 16px;
        color: #333333;
      }
      label{
        background: #EBF3FE;
        border-radius: 4px 4px 4px 4px;
        padding: 2px 4px;
        font-weight: 400;
        font-size: 12px;
        color: #3887F5;
        margin-left: 8px;
      }

      i{
        font-weight: 400;
        font-size: 14px;
        color: #999999;
      }

    }
    .case-texts{
      margin-top: 16px;
      p{
        display: flex;
        font-size: 14px;
        font-weight: 400;
        margin-bottom: 12px;

        &:last-child{
          margin-bottom: 0;
        }
      }
      label{
        color: #6B6B6F;
        flex: 0 0 80px;
      }
      span{
        color: #333333;
      }
      .fs15{
        font-size: 15px;
      }
      .money{
        font-weight: 500;
        font-size: 17px;
        color: #F78C3E;
      }
      .lawyers{
        font-size: 12px;
        color: #666666;

        img{
          width: 20px;
          height: 20px;
          border-radius: 10px 10px 10px 10px;
          border: 1px solid #FFFFFF;
          background-color: #2676E4;
          vertical-align: middle;
          margin-left: -5px;
          position: relative;
          top: -2px;
        }
      }
    }
    .lawyer-infos{
      //margin-top: 16px;

      li{
        margin-bottom: 16px;
        &:last-child{
          margin-bottom: 0;
        }
      }
      .lawyer-header{
        width: 48px;
        height: 48px;
        margin-right: 8px;
        vertical-align: bottom;
        border-radius: 50%;
        //display: block;
      }

      .lawyer-text{
        font-weight: 400;
        font-size: 12px;
        color: #9F6310;

        >div{
          display: inline-block;
        }
          .lawyer-icon{
            width: 12px;
            height: 12px;
            margin-right: 2px;
            vertical-align: middle;
            position: relative;
            top: -2px;
          }

        .lawyer-name{
          font-weight: 500;
          font-size: 16px;
          color: #333333;
          margin-bottom: 8px;
          label{
            color: #999999;
          }
        }
      }
      button{
        width: 74px;
        height: 32px;
        background: #3887F5;
        border-radius: 46px 46px 46px 46px;
        font-size: 13px;
        color: #FFFFFF;
        text-align: center;
        line-height: 32px;
        border: none;
        outline: none;
      }
    }
  }



  i{
    font-style: normal;
  }

}

.icons{
  width: 88px;
  height: 88px;
  top: 55px;
  right: 72px;
}
.footers{
  height: 130px;
  background: #FFFFFF;
  box-shadow: 0px -3px 10px 0px rgba(0,0,0,0.08);
  border-radius: 16px 16px 0px 0px;
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  text-align: center;
  button{
    width: 343px;
    height: 44px;
    background: linear-gradient(116deg, #71B5FF 0%, #2676E4 100%);
    border-radius: 68px 68px 68px 68px;
    font-size: 16px;
    font-weight: 500;
    color: #FFFFFF;
    border: none;
    margin:8px auto;
  }

  p{
    font-size: 14px;
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    color: #333333;
    margin-top: 12px;
    a{
      color: #3887F5;
    }
  }
}
.html-con{
  margin-top: 16px;
  margin-bottom: 16px;
}
.con-prompt-tit{
  color: #666666;
  margin-bottom: 8px;
}
.con-prompt-texts{
  color: #999999;
  p{
    margin-bottom: 12px;
    &:last-child{
      margin-bottom: 0;
    }
  }
}
</style>
